import React, { Component } from 'react';
import isContractInitialized from '../../utils/ContractInitializationState';
import LoadingAnimation from '../Components/LoadingAnimation';
import {
  addTransactionInProgress,
  transactionErrorHandler,
  transactionReceiptHandler
} from '../../utils/TransactionStateHelper';
import { TX_ENABLE_ADDRESS_BUY_COINS } from '../../utils/TransactionTypes';

export default class OwnerEnableBuyingCoinsForAddress extends Component {
  constructor (props) {
    super(props);

    this.state = {
      toAddress: '',
      contractLoaded: false
    };

    this.storageUnsubscribe = null;
  }

  componentDidMount () {
    this.isContractLoaded();
    this.storageUnsubscribe = Storage.subscribe(() => this.isContractLoaded());
  }

  isContractLoaded () {
    isContractInitialized() && !this.state.contractLoaded && this.init();
  }

  componentWillUnmount () {
    this.storageUnsubscribeHandler();
  }

  storageUnsubscribeHandler () {
    this.storageUnsubscribe && this.storageUnsubscribe();
  }

  init () {
    this.storageUnsubscribeHandler();
    this.setState({contractLoaded: true});
  }

  handleToAddressChange = (event) => {
    this.setState({
      toAddress: event.target.value
    });
  };

  handleFreezing = (event) => {
    // We don't want normal page submit
    event.preventDefault();

    if (this.state.toAddress === '') {
      window.notifications.showError('Receiving address is empty.');

      return;
    }

    window.contract
      .methods
      .setAllowedToBuy(this.state.toAddress)
      .send({from: Storage.getState().account.currentAccount, gasPrice: 0})
      .on('transactionHash',
        hash => addTransactionInProgress(hash, TX_ENABLE_ADDRESS_BUY_COINS))
      .on('receipt', (receipt) => transactionReceiptHandler(receipt, () => {
        this.setState({
          toAddress: '',
        });

        window.notifications.showSuccess('Address was successfully enabled.');
      }))
      .on('error', (err, receipt) => transactionErrorHandler(err, receipt));
  };

  renderForm () {
    if (!this.state.contractLoaded) {
      return (<LoadingAnimation/>);
    }

    return (
      <form onSubmit={this.handleFreezing}>
        <div className="c-form-row">
          <label>Address</label>
          <input type="text" placeholder="Address" name="toAddress" value={this.state.toAddress}
                 onChange={this.handleToAddressChange}/>
        </div>
        <div className="c-form-row">
          <input type="submit" value="Enable address"/>
        </div>
      </form>
    );
  }

  render () {
    return (
      <div className="c-component c-owner-freeze-address">
        <h2>Enable address to buy coins</h2>
        {this.renderForm()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OwnerDashboardPage/OwnerEnableBuyingCoinsForAddress.js